import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'

const Kitchen = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Bathroom Design App to Visualize, Plan, and Decorate Your Space"
        subtitle="Design your bathroom layout, try decor ideas, and plan a remodel — all in one easy-to-use app."
        bg={headerBg}
        meta={{
          title: 'Bathroom Design App | Design Layouts and Plan Your Remodel',
          description: 'Explore bathroom layout ideas and remodeling plans with our virtual bathroom design app. Visualize your design, preview products, and create the perfect bathroom setup with ease.'
        }}
        alt="Bathroom design app interface showing virtual bathroom layout and decor ideas"
      />
      <Join
        title="Join 10 Million+ Users Designing Bathrooms with DecorMatters"
        description="Design your bathroom with confidence using the DecorMatters bathroom design app. Plan layouts, place furniture, and preview decor in your space — all before making a purchase. Whether you're remodeling or just updating your style, our virtual bathroom design app makes it easy to try ideas, share your vision, and get inspired by a creative community."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Visualize and Shop Your Dream Bathroom in One App</H2>
            </Show>
            <Text>
              With the DecorMatters bathroom design app, you can plan your layout and explore real furniture and decor ideas — all in one place. Easily browse and test bathroom vanities, tiles, lighting, and storage options to see what fits your
              space. Then shop products from top brands directly in the app, turning your design into reality faster and with more confidence.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Visualize and Shop Your Dream Bathroom in One App</H2>
            </Show>
            <Image src={img1} alt="Virtual bathroom mockup with vanity, tile, lighting, and decor options from bathroom design app" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Design Your Bathroom on a Budget With Smart Planning Tools</H2>
            </Show>
            <Text>
              Remodeling your bathroom can boost your home's value — and our bathroom design app helps you do it without overspending. Plan layouts, try decor, and set a clear design vision using virtual tools that help you make confident decisions.
              Save money by visualizing your design before making any purchases.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Design Your Bathroom on a Budget With Smart Planning Tools</H2>
            </Show>
            <Image src={img2} alt="Bathroom layout visualization on mobile app showing affordable decor and smart planning tools" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Unlock Advanced Tools with Premium Membership</H2>
            </Show>
            <Text>
              Upgrade your design experience with DecorMatters Premium. Access powerful features that make your bathroom layout more precise and personalized:
              <br />
              <br />
              ● Upload real bathroom photos for accurate visualizations
              <br />
              ● Use lighting filters to preview ambiance
              <br />
              ● Save and organize your favorite products
              <br />
              ● Remove backgrounds from furniture images
              <br />● Access exclusive tools for faster, smarter designing
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Unlock Advanced Tools with Premium Membership</H2>
            </Show>
            <Image src={img3} alt="Premium bathroom design tools in app, including AR view and lighting filters for virtual decorating" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Download iOS App
              </ButtonLink>
            </Show>
            <Image src={img4} alt="Smartphone displaying virtual bathroom makeover created using DecorMatters design app" />
            <Content>
              <H2>Start Designing Your Dream Bathroom Today</H2>
              <Text>
                Download the DecorMatters bathroom design app to plan layouts, test furniture, and visualize every detail before making changes. From small upgrades to full remodels, our bathroom design app makes it easy to design your ideal space
                with confidence.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Download iOS App
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Kitchen
